import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const InfoTooltip = ({ children, content, placement = "top" }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip className="info-tooltip">{content}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  );
};

export default InfoTooltip;
